<template src='./share-rundown-dialog.html'></template>

<script>
//import componet from './path';

export default {
  name: "ShareRundown",
  components: {},
  props: {},
  data() {
    return {
      show: false,
      rundownId: "",
      link: "",
      occupiedSeats: "0",
      licenseSeats: "0",
      userList: [],
      showPremium: true
    };
  },
  methods: {
    handleShareRundown(rundownId, accessToken) {
      this.show = true;
      this.rundownId = rundownId;
      this.link = this.linkToShare(accessToken);
      this.licenseSeats = window.rundownApp.user.licenseSeats;
      this.userList = this.getUserList(rundownId);
      this.showPremium =  window.vueapp.showPremiumMode() && this.licenseSeats<10;
 
      this.$nextTick(function () { 
        //FIXME: es necesario refactorizar la ventana con componentes de vue
        var mainDiv = document.getElementById('info-shared-users');
        mainDiv.parentElement.style.zIndex="unset";
      });
      
    },
    linkToShare(accessToken) {
      let editor = window.rundownApp.rundownEditorUpdater.getInstance();
      return editor.getURLToCopy(accessToken);
    },
    copyLinkToShare() {
      window.$("#inputShareLinkId").select();
      document.execCommand("copy");
      window.vueapp.showToast(
        window.rundownApp.i18n.__("POPUP_EXPORT_RUNDOWN_COPY_OK")
      );
    },
    getUserList(rundownId) {
      window.rundownApp.api.getSharedUsersByRundownId(
        rundownId,
        (result) => {
          this.userList = result;
          this.occupiedSeats = result.length
        },
        (err) => {
          alert(err);
        }
      );
    },
    removeShare(userId) {
      window.rundownApp.api.unshareRundown(this.rundownId, userId,
        () => {
          window.rundownApp.api.getSharedUsersByRundownId(this.rundownId,
          () => {
             this.getUserList(this.rundownId)
            },
            (err) => {
              alert(err);
            }
          );
        },
        (err) => {
          alert(err);
        }
      );
    },
    goToProfile() {
      this.show = false;
      window.vueapp.handleProfileDialog(window.rundownApp);
    }
  },
  filters: {},
  computed: {},
  created() {},
  mounted() {},
  updated() {},
  destroyed() {},
};
</script>


<style>
</style>